export const staffMembersHandler = {
    pathPattern: '/brands/:brandId/staff/members',
    toWeb: ({ brandId }) => ({ path: `/brands/${brandId}/staff/members` }),
    meta: {
        title: 'Staff members',
        description: 'Opens the brand staff members list in the dashboard.',
        status: 'live',
        platforms: { web: true, ios: false, android: false },
        flag: null,
        params: [{ name: 'brandId', in: 'path', required: true }],
        example: { params: { brandId: 'BXqExampleBrandId' } },
    },
};
//# sourceMappingURL=staff-members.js.map